import ErgAuthService from '@ergeon/erg-auth';

const COOKIE_PARAM_NAME = 'cookieName';
const OPTIONAL_SETTINGS = {};
if (process.env.AUTH_COOKIE_NAME) {
  OPTIONAL_SETTINGS[COOKIE_PARAM_NAME] = process.env.AUTH_COOKIE_NAME;
}

export const authService = new ErgAuthService({
  ...OPTIONAL_SETTINGS,
  appId: 'ergeon',
  idService: process.env.ID_SERVICE,
  userDetailsEndpoint: `${process.env.API_HOST}/api/v1/authenticate/help/`,
  level: process.env.LEVEL || 'development',
  mockJWT: process.env.MOCK_JWT,
});

// Workaround: erg-auth double-encodes the `next` URL
// (encodeURIComponent + query-string.stringify both encode).
// Override to use URLSearchParams which encodes correctly once.
const _originalAuthenticate = authService.authenticate;
authService.authenticate = function(nextUrl = window.location.href, skipLogin = false) {
  if (this.options.mode === 'otp') {
    return _originalAuthenticate.call(this, nextUrl, skipLogin);
  }
  const params = new URLSearchParams();
  params.set('next', nextUrl);
  if (skipLogin) params.set('skip-login', 'true');
  window.location.href = `${this.options.authenticateUrl}?${params.toString()}`;
};
